<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Pošiljanje obrazcev za obnovo prijave {{$route.query.title}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
        Skriti stolpci:
              <kendo-multiselect 
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="pageable"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        

                        :selected-field="selectedField"
                        @selectionchange="onSelectionChange"
                        @headerselectionchange="onHeaderSelectionChange"
                      


                        :pageSize="pageSize"
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        @pagechange="pageChangeHandler"
                        
                       :resizable="true"
                        
                  
                       
                        >




                    <template v-slot:filterSlotTemplate="{props, methods}">
            <div>
              <dropdownlist

                :data-items="kategorije"
                :text-field="'kratkinaziv'"
                @change="filterKategorijaChange"
             
                
            /></div>
          </template>
            
              <template v-slot:filterVrsteSlotTemplate="{props, methods}">
            <div>
              <dropdownlist
                :data-items="vrste"
                :text-field="'naziv'"
                
            /></div>
          </template>
            
              
              
            <template v-slot:shemaCommandCellSlot="{props, methods}">
                      <shemaCommandCell :ukazi="ukazi" :dataItem="props.dataItem" :shema="$route.query.title"/>
            </template>



                     <template v-slot:shemaCell="{props}">
                      <shemaCell :sheme="props.dataItem.sheme"/>
                    </template>

                    <template v-slot:kategorijaCell="{props}">
                      <listCell :list="props.dataItem.sheme.find(s=>s.sezona==2022&&s.shema==$route.query.title).kategorije.map(i=>i.id?i.id:i)"
                        :displayname="'kratkinaziv'"
                        hover="naziv"
                        :sifrant="kategorije"
                        sifrantid="id"
                        :data-item="props.dataItem" 
                        dataitemname="kategorije"

                        />
                    </template>
                    <template v-slot:dejavnstiCell="{props}">
                      <listCell :list="props.dataItem.sheme.find(s=>s.sezona==2022&&s.shema==$route.query.title).vsedejavnosti"
                                                
                             :displayname="'naziv'"
                              :data-item="props.dataItem" 
                               dataitemname="dejavnosti"
                        />
                    </template>
                    <template v-slot:statusCell="{props}">
                      <td colspan="1"><span>
                        {{ props.dataItem.sheme.find(s=>s.sezona==2022&&s.shema==$route.query.title).status }}
</span></td>
                    </template>

                    <template v-slot:obnovaObrazec="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command"
                        :href="'/javno/obrazci/obnovaprijave/'+props.dataItem._id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="magnifying-glass"/>
                         
                    </a>
                </td>
                    </template>

                    <template v-slot:obnovaObrazecShranjen="{props}">
                    <td>
                      <a v-if="props.dataItem.datoteka?true:false"
                        class="k-button k-grid-edit-command k-primary"
                        :href="apiUrl+'/obrazci/vrni/Obr3.21/'+props.dataItem._id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="file-pdf"/>
                         
                    </a>
                </td>
                    </template>

                     <template v-slot:obnovaObrazecPoslan="{props}">
                    <td>
                      <span  v-if="mailsprejet(props.dataItem.datoteka)"
                        class="k-primary k-button k-grid-edit-command"
                        :title="(new Date(props.dataItem.datoteka.datumposiljanja)).toLocaleString()">
                         <font-awesome-icon icon="envelope-circle-check"/>
                         
                    </span>
                   <span  v-if="mailzavrnjen(props.dataItem.datoteka)"
                        class="k-error k-button k-grid-edit-command"
                       
                        :title="(new Date(props.dataItem.datoteka.datumposiljanja)).toLocaleString()">
                         <font-awesome-icon icon="envelope-circle-check"/>
                         
                    </span>
               
                </td>
                    </template>

                    <template v-slot:email="{props}">
                    <td>
                    <span v-for="posta in emails(props.dataItem)">  
                         {{posta}}
                        
                    </span>
               
                </td>
                    </template>

                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.jeaktivna"/>
                    </template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                     
                       <!--
                             <button v-if="userDetails.pravice.includes('STRANKE_PISI')"
                                title="Dodaj KMG"
                                class="k-button k-primary"
                                @click="dodajPridelovalca"
                            >
                                Dodaj
                            </button>
                        -->
                            
                            <button
                                title="Ustvari obrazec"
                                class="k-button k-primary"
                                @click="generiraj"
                                :disabled="generiranje"
                            >
                                Generiraj obrazce
                            </button>
                             <button
                                title="Pošlji po e-pošti"
                                class="k-button k-primary"
                                @click="poslji"
                                 :disabled="posiljanje"
                            >
                                Pošlji po e-pošti
                            </button>

                            
                           
                        </div>
                         <div>Izbranih je {{countSelected}}</div>   
                        </toolbar>
                    </Grid>

                    </div>
    </div>

</template>
<style scoped>
.k-error,.k-error:hover,.k-error:active,.k-error:focus
{
background-color:var(--error);
border-color:var(--error);
color: #ffffff;
background-image: linear-gradient(rgba(9, 136, 100, 0), rgba(9, 136, 100, 0.2));
}

</style>
<script>
import { mapState, mapActions,mapMutations } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import ShemaCell from './support/ShemaCell';
import ListCell from './support/ListCell';
import ShemaCommandCell from './support/ShemaCommandCell';

import CheckBoxGridItem from './support/CheckBoxGridItem';
Vue.component('kendo-multiselect', MultiSelect);

import { process } from '@progress/kendo-data-query';

import { authHeader,logout, handleResponse } from '../helpers';






export default {
     props:["sezona"],
      components:{
      'dropdownlist': DropDownList,
      'shemaCell': ShemaCell,
      'listCell': ListCell,
      'shemaCommandCell': ShemaCommandCell,
      'cbItem': CheckBoxGridItem,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
            dataSezona:this.sezona,
            apiUrl:Vue.prototype.$config.apiUrl,
            selectedField: 'selected',
           pridelava:[],
            girdDataApi:null,
            gridData:null,
            generiranje:false,
            posiljanje:false,
            filter:{
                logic: "and",
                filters: [
                    { field: "jeaktivna", operator: "neq", value: 0}
                ]
            },
             
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
                { field: 'ime', dir: 'asc' }
            ],
           
           ukazi:[],
           kategorije:[],
           vrste:[]

            

        }
    },
    created () {

            



        if(!this.$route.query.sezona)
            this.dataSezona={sezona:2022};
        else
            this.dataSezona={sezona:this.$route.query.sezona};

        var thisComp=this;
        
            this.naloziPodatke();
         



     },
     beforeRouteUpdate (to, from,next) {
    
        if(!this.$route.query.sezona)
            this.dataSezona={sezona:2022};
        else
            this.dataSezona={sezona:this.$route.query.sezona};
        
        this.loadShema({sezona:this.dataSezona.sezona,shema:to.query.title}).then(x=>{
            //console.log("iščem ukaze");
            //console.log(this.sheme);
            //console.log(to.query.title);
            this.ukazi=this.sheme.find(i=>i.kratica==to.query.title).ukazi;
            
            next();
        });
        
    

 
    },



    computed: {
               
        pageable(){
            return { buttonCount: 4, pageSizes: [10,100,this.pridelava?.length] }
        },
        countSelected() {
            //console.log(this.pridelava);

            return this.pridelava?.filter(item=>item.selected).length;
        },
        areAllSelected () {
            return this.pridelava?.findIndex(item => item.selected === false) === -1;
        },

        //...mapState('pridelava', ['pridelava','storedfilter']),
         ...mapState('sifrant', ['sifrant','dataSezone']),
        ...mapState('users', ['userDetails','sezonePisanje','sheme']),
        hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
        columns() {

            let columns=[
                {field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected,filterable:false,columnMenu: null,sortable:false},
                { field: "naziv", title:"Naziv"},
                { field: "kmgmid", title:"KMG-MID"},
                { field: "id", title:"Kontrolna št.",width:"80px"},
                { field: "naslov", title:"Naslov",hidden:true},
                { field: "postnastevilka", title:"Poštna št.",hidden:true},
                { field: "posta", title:"Pošta",hidden:true},
                { field: "obcina", title:"Občina",hidden:true},
                //{ field: "statisticnaregija", title:"Statistična regija KMG"},
                
                { title: "e-mail",field:"email", cell: 'email',filterable:false,columnMenu: null,width:"250px"},
                //{ field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                //{ field: "postanosilca", title:"Pošta nosilca",hidden:true},
                //{ field: "statuspridelovalca", title:"Status"},
                //{ field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                { field: "davcnastevilka", title:"Davčna številka",hidden:true},
                { field: "mso", title:"MŠO",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                //{ field: "imavezanezivali", title:"Vezana reja",hidden:true},
                //{ field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                //{ field: "sheme", title:"Sheme",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                { title: "Predogled obrazca", cell: 'obnovaObrazec',filterable:false,columnMenu: null,width:"50px",sortable:false},
                { title: "Shranjen obrazec", cell: 'obnovaObrazecShranjen',filterable:false,columnMenu: null,width:"50px",sortable:false},
                { title: "Obrazec poslan", cell: 'obnovaObrazecPoslan',filterable:false,columnMenu: null,width:"50px",sortable:false},
                
            ];

            //if(this.userDetails.pravice.includes("STRANKE_PISI"))
                //columns.unshift({ title: "Ukazi", cell: "shemaCommandCellSlot",filterable:false,columnMenu: null,width:((this.ukazi.length*28)+6)+"px",sortable:false,hidden:true});

            //if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
              //  columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});

              if(this.$route.query.title=="EKO PRI"||this.$route.query.title=="EKO PRE"){
                
                columns.push({field:"kategorije", title:"Kategorije",cell:"kategorijaCell",hidden:true});
                columns.push({field:"dejavnosti" ,title:"Dejavnosti",cell:"dejavnstiCell",hidden:true});
                columns.push({field:"status.status" ,title:"Status",hidden:true});
                //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
              }




            return columns;


        }

           },
      watch: {
        skip(newValue, oldValue){
           

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        take(newValue, oldValue){
         
       /*  if(isNaN(this.take))
            this.take=this.pridelava.length;
         */   
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                group: this.group
            }
        this.dataResult = process( this.pridelava, dataState);
        },
      pridelava(newValue, oldValue) {
    

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        }
    }
},
    methods: {

        ...mapActions('pridelava', ['load','replace','loadShema']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('pridelava',['updatefilter']),


        async   naloziPodatke   (){

            var thisComp=this;
                this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}).then(()=>{

            thisComp.kategorije=thisComp.sifrant["kategorije"];   
            this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapridelovalca"}).then(()=>{
            thisComp.vrste=thisComp.sifrant["vrstapridelovalca"];

           
          /*  thisComp.loadShema({sezona:thisComp.dataSezona.sezona,shema:thisComp.$route.query.title}).then(t=>{
                    this.pridelava.forEach (item=>{
                             Vue.set(item,"selected",false);
                            })

            thisComp.ukazi=thisComp.sheme.find(i=>i.kratica==thisComp.$route.query.title).ukazi;
        });
        */
            
            
        });         
        });

             const requestOptions = {
            method: 'GET',
            headers: authHeader(),
            };
            var response = await fetch(`${this.apiUrl}/obrazci/stranke/?sezona=${thisComp.dataSezona.sezona}&shema=${thisComp.$route.query.title}&obrazec=Obr3.21`, requestOptions);
            console.log(response);
            this.pridelava = await response.json();
                 this.pridelava.forEach (item=>{
                             Vue.set(item,"selected",false);
                             Vue.set(item,"email",item.kontakt.find(i=>i.vloga=="nosilec kmg")?.email.join(" ").trim());
                            })


        },
        emails(stranka){
            var nosilec=stranka.kontakt.find(i=>i.vloga=="nosilec kmg");
            return nosilec.email;

        },
        mailsprejet(item){

        return (item?.emailinfo?.accepted)?.length>0?true:false;

        },
        mailzavrnjen(item){
              return (item?.emailinfo?.rejected)?.length>0?true:false;

        },
        onHeaderSelectionChange (event) {
            let checked = event.event.target.checked;
            this.pridelava.forEach (item=>{
               item.selected=checked;
            })

        },
        onSelectionChange (event) {
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
    
        },
        onRowClick (event) {
            
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
            //Vue.set(this.pridelava,this.pridelava.indexOf(event.dataItem),event.dataItem);
               
        },

         skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
           
        },
        
      
        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        sezonaChange(event) {
            const sezona = event.value;
            
            this.$router.push({ path: this.$route.path, query: { sezona:sezona.sezona,title:this.$route.query.title} })
            this.dataSezona=sezona;
            this.loadShema({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


        },

        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
           
            this.dataResult = process(this.pridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
          

        },
        formatDate: function (h, emptyElement , props, listeners ) {
          
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
        dodajPridelovalca(){

              this.$router.push({ name: 'dodajStranko'})

        },
        async generiraj () {
        this.generiranje=true;
        let izbrani=this.pridelava.filter(i=>i.selected);
        //izbrani.push({id:123,url:"http://okolje.kkptuj.si/javno/certifikatpdf/63442d2991ed8f4bacb9f05c"});
        
        for (let stranka of izbrani){

         const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',...authHeader()},
            body: JSON.stringify(stranka)
        };
        var response = await fetch(`${this.apiUrl}/obrazci/generate/single/Obr3.21/`, requestOptions);
        var datoteka = await response.json();
        console.log(datoteka);
        
        Vue.set(stranka,'datoteka',datoteka);
        Vue.set(stranka,'selected',false);

        }
        
        this.generiranje=false;
        

        },
        async poslji () {

        this.posiljanje=true;
       let izbrani=this.pridelava.filter(i=>i.selected)
       
       for (let stranka of izbrani){

         const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',...authHeader()},
            body: JSON.stringify(stranka)
        };
        var response = await fetch(`${this.apiUrl}/obrazci/send/single/Obr3.21/`, requestOptions);
        var datoteka = await response.json();
        console.log(datoteka);
        
        Vue.set(stranka,'datoteka',datoteka);
        Vue.set(stranka,'selected',false);

        }
           this.posiljanje=false;
        console.log(izbrani)
        },
        exportExcel () {
            
            this.saveExcel({
                data: process(this.pridelava, {
                
                sort: this.sort,
                filter: this.filter,
                group: this.group
            }).data,
                fileName:this.dataSezona.sezona+ "_PRIDELOVALCI",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },

         pageChangeHandler: function(event) {
            
            this.skip = event.page.skip;
           
            this.take = event.page.take;
            console.log(this.take);
           
        },
        filterKategorijaChange: function(ev) {

            console.log(this.filter);
            

              const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        
    }
};
</script>

